// extracted by mini-css-extract-plugin
module.exports = {"skeleton-q8sx1kczrff":"_4f720283bf--skeleton-q8sx1kczrff--pLpvq","shineForSkeleton-q8sx1kczrff":"_4f720283bf--shineForSkeleton-q8sx1kczrff--kHwkN"};